export default __webpack_public_path__ + "static/media/Cost_Icon.089c0ce5.png";